/**
 * Created by SG0949773 on 10/22/2015.
 */
'use strict';

var ConfigurationLegAssignmentDirective = function ConfigurationLegAssignmentDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationLegAssignmentController',
    template: require('../templates/configuration-leg-assignment.html'),
    link: function link(scope) {
      scope.$on('configuration-leg-assignment:saveChanges', scope.saveChanges);
      scope.$on('configuration-leg-assignment:loadedSuccessful', scope.loadedSuccessful);
      scope.$on('configuration-leg-assignment:removeLegAssignment', scope.removeLegAssignment);
    }
  };
};
ConfigurationLegAssignmentDirective.$inject = [];
module.exports = ConfigurationLegAssignmentDirective;